<template>
<div class="chapter">
<div class="inner_page">
<div class="MAIN_PAGE" id="d5e1498">
<p class="toc"><b>Contents</b></p>
<p class="toc1" id="pa"><a href="#/partone#ta">Part One</a></p>
<p class="toc2" id="c001"><a href="#/chapter1#c01">Chapter 1</a></p>
<p class="toc2" id="c002"><a href="#/chapter2#c02">Chapter 2</a></p>
<p class="toc2" id="c003"><span href="#/chapter3#c03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc2" id="c004"><span href="#/chapter4#c04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc1" id="c00qa"><span href="#/parttwo#c00la" title="Link target outside of Sample">Part Two</span></p>
<p class="toc2" id="c005"><span href="#/chapter5#c05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc2" id="c006"><span href="#/chapter6#c06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc2" id="c007"><span href="#/chapter7#c07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc2" id="c008"><span href="#/chapter8#c08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc2" id="c009"><span href="#/chapter9#c09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc2" id="c010"><span href="#/chapter10#c10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc1" id="c011"><span href="#/bio" title="Link target outside of Sample">A Biography of William Styron</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6a20ef58